import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

export default function Names({ id, state, onChange }) {
  const path = localStorage.getItem("path");

  function handleChange(event) {
    const { id: _id, value } = event.target;
    const inputElement = document.getElementById(_id);
    const errorElement = inputElement.nextSibling;

    if (_id === id + "FirstName") {
      if (value.trim().length === 0) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The First name can't be empty";
        errorElement.style.display = "block";
      } else if (!/^[ a-zA-Z\\&-]+$/.test(value)) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The First name should contain only letters and & \\ - symbols";
        errorElement.style.display = "block";
      } else if (value.toString().toLowerCase().includes("null")) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = 'The First name can\'t contain "Null" name.';
        errorElement.style.display = "block";
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }
    if (_id === id + "MiddleName") {
      if (value.trim().length !== 0) {
        if (!/^[ a-zA-Z\\&-]+$/.test(value)) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML = "The Middle name should contain only letters and & \\ - symbols";
          errorElement.style.display = "block";
        } else {
          errorElement.style.display = "none";
          inputElement.classList.remove("is-invalid");
        }
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }
    if (_id === id + "LastName") {
      if (value.trim().length === 0) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The Last name can't be empty";
        errorElement.style.display = "block";
      } else if (!/^[ a-zA-Z\\&-]+$/.test(value)) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The Last name should contain only letters and & \\ - symbols";
        errorElement.style.display = "block";
      } else if (value.toString().toLowerCase().includes("null")) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = 'The Last name can\'t contain "Null" name.';
        errorElement.style.display = "block";
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }
    onChange(event);
  }

  return (
    <>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>First Name</strong>
            <br />
            The executor is a person named in a will who manages the estate of a deceased individual.
          </Tooltip>
        }
      >
        <Form.Group controlId={id + "FirstName"}>
          <Form.Label>First name</Form.Label>
          <Form.Control
            required
            data-hj-allow
            type="text"
            placeholder="First name"
            pattern="^[ a-zA-Z&\\-]+$"
            maxLength="30"
            defaultValue={state && path === "EINEstate" ? state.representativeFirstName : state.representativeFirstName}
            onKeyPress={(event) => {
              if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
            }}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">Please provide a valid name</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Middle Name</strong>
            <br />
            The executor is a person named in a will who manages the estate of a deceased individual.
          </Tooltip>
        }
      >
        <Form.Group controlId={id + "MiddleName"}>
          <Form.Label>Middle name (optional)</Form.Label>
          <Form.Control
            type="text"
            placeholder="Middle name"
            pattern="^[ a-zA-Z&\\-]+$"
            maxLength="30"
            onKeyPress={(event) => {
              if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
            }}
            onChange={handleChange}
            data-hj-allow
            defaultValue={
              state && path === "EINEstate" ? state.representativeMiddleName : state.representativeMiddleName
            }
          />
          <Form.Control.Feedback type="invalid">Please provide a valid name</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Last Name</strong>
            <br />
            The executor is a person named in a will who manages the estate of a deceased individual.
          </Tooltip>
        }
      >
        <Form.Group required controlId={id + "LastName"}>
          <Form.Label>Last name</Form.Label>
          <Form.Control
            required
            data-hj-allow
            type="text"
            placeholder="Last name"
            maxLength="30"
            pattern="^[ a-zA-Z&\\-]+$"
            defaultValue={state && path === "EINEstate" ? state.representativeLastName : state.representativeLastName}
            onKeyPress={(event) => {
              if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
            }}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">Please provide last name</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
    </>
  );
}
